module.exports = __webpack_public_path__ + "img/Image36.1763448e.jpg";